import {call, put, takeEvery} from "redux-saga/effects";
import {bienLaiThuApi} from "../../../api/bien-lai/bienLaiThuApi";
import {IBienLaiSelectByThiSinhRequest} from "../../../model/request/bien-lai/IBienLaiSelectByThiSinhRequest";
import {IBaseRespone} from "../../../model/respone/IBaseRespone";
import {
    eBienLaiViewTuyenSinhActionTypeIds,
    IBienLaiViewTuyenSinhActionTypes,
} from "../../action-types/bien-lai/IBienLaiViewTuyenSinhActionTypes";
import {rootActions} from "../../actions/rootActions";

export function* bienLaiViewTuyenSinhSaga(): any {
    yield takeEvery(eBienLaiViewTuyenSinhActionTypeIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IBienLaiViewTuyenSinhActionTypes): any {
    const request = action.payload as IBienLaiSelectByThiSinhRequest;
    const res: IBaseRespone = yield call(bienLaiThuApi.SelectByThiSinh, request);
    if (res.is_success) {
        yield put(
            rootActions.bienLai.bienLaiViewTuyenSinh.LOAD_SUCCESS({
                request,
                data: res.data,
            })
        );
    } else {
        yield put(
            rootActions.bienLai.bienLaiViewTuyenSinh.LOAD_ERRR({
                request,
                data: res.data,
            })
        );
    }
}
